import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import "./step-content.scss";

const block = "step-content";

const StepContent = ({ imageUrl, stepTitle, children }) => (
  <div className={`${block}`}>
    <div className={`${block}__panel`}>
      <h2 className={`${block}__step-title`}>{stepTitle}</h2>
      {children}
    </div>
    <div className={cn(`${block}__panel`, `${block}__panel--right`)}>
      <img
        className={`${block}__icon`}
        aria-hidden="true"
        alt={stepTitle}
        src={imageUrl}
      />
    </div>
  </div>
);

StepContent.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  stepTitle: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired
};

export default StepContent;
